module.exports = __webpack_public_path__ + "img/logo_vivacoid.ab1b2c7d.png";